import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Качество`,
    content: {
      description: `<p>Набор пенал на 12 шоколадок.<br>Размер 170х140х15мм<br>Наполнение: 12 шоколадок по 5 г</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
